var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareMegamenuIconLive = function SvgYeswareMegamenuIconLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17a4.167 4.167 0 1 0 0-8.333A4.167 4.167 0 0 0 18 17Zm0 2.083c-4.175 0-7.575 2.8-7.575 6.25 0 .234.183.417.417.417h14.316a.413.413 0 0 0 .417-.417c0-3.45-3.4-6.25-7.575-6.25Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareMegamenuIconLive;